import * as React from 'react'

function IconGirl(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={175}
      height={175}
      viewBox="0 0 175 175"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M87.5 175c48.325 0 87.5-39.175 87.5-87.5S135.825 0 87.5 0 0 39.175 0 87.5 39.175 175 87.5 175z"
        fill="#1978B2"
      />
      <path
        d="M84.575 19.6c-1.282.481-2.685.538-3.988.113-6.163-2.012-25.706-6.17-38.427 16.39C29.53 58.502 32.024 92.7 25.989 114.453c-2.04 7.345 1.827 15.045 8.981 17.694 23.39 8.677 71.407 21.569 109.373-.347 5.207-3.003 7.955-8.975 7.006-14.91-4.633-28.964-22.185-114.006-66.774-97.29z"
        fill="#F4BA27"
      />
      <path
        d="M147.014 90.305c.432 6.41-4.47 12.162-10.873 12.736-.333.028-.659.043-.992.05-3.031.028-5.787 1.742-7.033 4.505-7.438 16.475-23.319 25.606-39.596 26.633-16.469.559-33.334-7.14-42.266-23.141-1.325-2.373-3.974-3.726-6.665-3.372-.206.028-.418.05-.624.064-6.382.503-12.176-4.271-12.863-10.632-.744-6.92 4.484-12.934 11.326-13.267h.021c1.254-.057 2.274-1.034 2.295-2.288.567-34.368 21.647-52.863 43.577-54.095 21.916-.907 44.681 15.427 48.613 49.526.141 1.26 1.246 2.182 2.514 2.125h.021c6.531-.312 12.099 4.654 12.545 11.156z"
        fill="#fff"
      />
      <path
        d="M130.843 89.766a.851.851 0 01-.624-1.473c.185-.17 4.562-4.172 12.339-2.762a.852.852 0 11-.304 1.679c-6.899-1.247-10.71 2.181-10.873 2.33a.787.787 0 01-.538.226z"
        fill="#000"
      />
      <path
        d="M141.34 91.502a.867.867 0 01-.722-.333c-2.515-3.294-5.979-3.428-6.12-3.435a.853.853 0 01-.829-.872.848.848 0 01.871-.828c.177.007 4.406.141 7.438 4.108a.858.858 0 01-.163 1.197 1.031 1.031 0 01-.475.163zM43.293 94.038a.877.877 0 01-.56-.177c-.176-.135-4.306-3.173-11.05-1.26a.855.855 0 01-.467-1.643c7.608-2.162 12.353 1.394 12.552 1.543a.85.85 0 01.156 1.197.794.794 0 01-.63.34z"
        fill="#000"
      />
      <path
        d="M33.015 96.78a.852.852 0 01-.765-1.303c2.628-4.244 6.829-4.79 7.006-4.81a.848.848 0 01.949.743.853.853 0 01-.744.95c-.149.02-3.577.495-5.759 4.016a.866.866 0 01-.687.403zM88.35 100.59a.854.854 0 01-.475-1.587c2.402-1.43 3.684-2.642 3.811-3.584.114-.864-.793-1.806-1.841-2.897-.638-.659-1.353-1.41-1.97-2.267-2.755-3.86-2.323-18.976-2.266-20.69a.853.853 0 01.878-.822c.475.014.843.411.822.879-.149 4.49-.092 16.766 1.955 19.642.538.758 1.183 1.423 1.806 2.075 1.296 1.353 2.529 2.628 2.302 4.307-.205 1.55-1.636 3.038-4.625 4.823a.917.917 0 01-.397.121zM110.344 91.177c1.337-.065 2.327-2.025 2.212-4.377-.114-2.352-1.291-4.206-2.627-4.141-1.336.065-2.327 2.025-2.212 4.377.115 2.352 1.291 4.206 2.627 4.14zM65.65 93.36c1.336-.066 2.326-2.026 2.211-4.378-.114-2.352-1.29-4.206-2.627-4.141-1.336.065-2.326 2.025-2.212 4.377.115 2.352 1.291 4.206 2.627 4.141z"
        fill="#000"
      />
      <path
        d="M114.882 105.281c4.959-2.231 7.892-6.455 6.552-9.433-1.34-2.979-6.446-3.585-11.405-1.354s-7.892 6.454-6.552 9.433c1.341 2.979 6.447 3.585 11.405 1.354zM73.568 105.393c1.045-3.095-2.285-7.013-7.438-8.752-5.152-1.738-10.175-.638-11.22 2.457-1.044 3.095 2.286 7.013 7.439 8.751 5.152 1.739 10.175.639 11.22-2.456z"
        fill="#FFDEDE"
      />
      <path
        d="M33.164 72.193C79.56 70.26 86.99 50.738 86.99 50.738s14.145 10.922 44.979 14.946l-8.911-29.998-33.37-13.99-36.294 9.577-20.23 40.92z"
        fill="#F4BA27"
      />
      <path
        d="M55.944 79.39a.85.85 0 01-.807-1.226c.056-.113 5.532-10.979 17.077-8.698.46.092.765.538.673 1.006a.862.862 0 01-.999.673c-10.25-2.026-15.016 7.373-15.215 7.777a.879.879 0 01-.73.468zM119.177 75.877a.847.847 0 01-.765-.404c-.234-.383-5.901-9.28-15.902-6.262a.853.853 0 01-1.063-.573.851.851 0 01.574-1.063c11.276-3.393 17.779 6.892 17.843 6.998a.857.857 0 01-.687 1.304zM81.741 109.529c0-3.719 3.025-6.743 6.75-6.743a6.75 6.75 0 016.744 6.743c0 3.719-3.025 6.75-6.743 6.75-3.72-.007-6.75-3.031-6.75-6.75zm1.58 0a5.177 5.177 0 005.17 5.171 5.177 5.177 0 005.171-5.171 5.172 5.172 0 00-5.17-5.171 5.172 5.172 0 00-5.171 5.171z"
        fill="#000"
      />
    </svg>
  )
}

export default IconGirl
